import styled from 'styled-components'
import { PageMain } from 'styles'
import { Theme } from 'styles/Themes'

interface Props {
  reqLoading?: boolean
}

export const Container = styled(PageMain)<{ isExpanded: boolean }>`
  padding-top: 0px;
  padding-left: 0px;
  padding-bottom: 0px;

  .financial-right-container {
    display: flex;
    flex-direction: column;
    transition: all 1s;
    width: ${({ isExpanded }) =>
      isExpanded ? 'calc(100% - 252px)' : 'calc(100% - 48px)'};
    max-width: 100%;
    height: fit-content;
    padding-bottom: 24px;
    gap: 24px;

    ::-webkit-scrollbar {
      width: 8px;
      background-color: #c4c4c4;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track {
      background: white;
      border: 0;
    }
    ::-webkit-scrollbar-thumb {
      width: 8px;
      background-color: #c4c4c4;
      border-radius: 50px;
    }
  }

  .financial-path {
    color: #868686;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.14px;
  }

  .financial-title {
    color: #000;

    /* H1 - Títulos */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media only screen and (min-width: 1441px) {
      font-size: 18px;
    }
    /* margin-bottom: 32px; */
  }

  .financial-left-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: ${({ isExpanded }) => (isExpanded ? 'visible' : 'hidden')};
  }

  .financial-cards-container {
    display: flex;
    gap: 24px 32px;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    /* margin-bottom: 30px; */
  }

  .container-kanban {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    height: 100%;
  }
`
export const KanbanEnviromnent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  opacity: ${(props: Props) => {
    if (props.reqLoading) return 0.4
    return 1
  }};
  pointer-events: ${(props: Props) => {
    if (props.reqLoading) return 'none'
    return 'auto'
  }};

  @keyframes load {
    to {
      transform: rotate(360deg);
    }
  }

  .grey-loagind {
    position: absolute;
    top: 50%;
    left: 50%;
    /* transform: translate(-50%, -50%); */
    animation: load 2s infinite linear;
    height: 80px;
    width: 80px;
    filter: ${Theme.icons.TERTIARY2};
  }
`

export const Line = styled.div`
  height: 46px;
  border: 1px solid #eeeeee;
  width: 0px;
`
